import { Backdrop, CircularProgress } from "@mui/material";

const LoadingOverlay = ({ open }: { open: boolean }) => {
    return (
        <Backdrop open={open} sx={{ zIndex: 10 }}>
            <CircularProgress />
        </Backdrop>
    )
}

export default LoadingOverlay;
